import { StepKey } from '../utils/stepNavigation';

/**
 * Maps step keys to their associated form field names.
 * Used for error navigation - when an API returns a field error,
 * this mapping determines which step to navigate to.
 */
export const STEP_KEY_TO_FIELDS: Record<StepKey, string[]> = {
  ROLE_SELECTION: ['ROLE_SELECTION', 'onboarding_role'], // Form field name + server field name
  COMPLETE_ACCOUNT: [
    'zip_code',
    'academicEnrollmentTypes',
    'academicsCurrentEnrollment',
    'academicProgramStartTerm',
    'academicProgramStartYear',
    'academicExpectedGraduationYear',
  ],
  ACTIVATION_CODE: ['invite_code'],
  SELECT_PLAN: [],
  INVITE_FAMILY: [],
};

/**
 * Get the step key for a given field name.
 * Used for error navigation to determine which step to show.
 */
export function getStepKeyForField(fieldName: string): StepKey | undefined {
  for (const [stepKey, fields] of Object.entries(STEP_KEY_TO_FIELDS)) {
    if (fields.includes(fieldName)) {
      return stepKey as StepKey;
    }
  }

  return undefined;
}
